module.exports = __webpack_public_path__ + "img/sponsor_header.8b00fe8a.png";